import { getGeo, getActiveGroups } from './onetrust';
import { detectFramework } from './consent-utils';
import type { ConsentSnapshot } from './models/consent';

export function buildConsentSnapshot(): ConsentSnapshot {
  const { country, state } = getGeo();
  const activeGroups = getActiveGroups();

  return {
    ready: true,
    country,
    state,
    framework: detectFramework(country, state),
    activeGroups,
  };
}
